var render = function render(){var _vm=this,_c=_vm._self._c;return _c('GenericDrawer',_vm._g({attrs:{"colorKey":"bgDrawerApp","isSubDrawer":false,"isOpen":_vm.isOpen,"topLinks":_vm.topLinks,"bottomLinks":_vm.bottomLinks}},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }